import React from "react";
import classNames from "classnames";

export const ToggleButton = ({ id, value, onChange, disabled = false }) => {
  return (
    <label
      htmlFor={id}
      className={classNames(
        "inline-flex relative items-center select-none",
        disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
      )}
    >
      <input
        type="checkbox"
        value={value}
        onChange={onChange}
        id={id}
        checked={value}
        disabled={disabled}
        className="sr-only peer"
      />
      {/* Track + Thumb via Tailwind peer utilities */}
      <div className="w-9 h-5 bg-gray-200 rounded-full peer peer-checked:bg-primary transition-colors duration-200 peer-focus-visible:ring-2 peer-focus-visible:ring-primary/30 peer-focus-visible:ring-offset-1 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:shadow-sm after:transition-all after:duration-200 peer-checked:after:translate-x-4" />
    </label>
  );
};
